import './PDC_table.css';
import { useEffect, useState } from 'react';


function PDC_table() {
    const [comptes, setComptes] = useState([]);

    useEffect(() => {
        fetch("https://api.famillerocher.fr/api_compta/get.compta.all.comptes.php/",{
            method: "GET"
        })
            .then(r => r.json())
            .then(data => {
                // console.log("DATA API:",data);
                setComptes(data)
            })
            .catch(err => console.error("API error:", err));
    }, []);


    
    return (
        // <h1>PageDataComptes</h1>
        // <div>
        //     <ul>
        //         {comptes.map((compte) => (
        //             <li key={compte.id_dc_num}>
        //                 {compte.id_dc_num} — {compte.dc_label}
        //             </li>
        //         ))}
        //     </ul>
        // </div>
        <table>
            <thead>
                <tr>
                    <th scope='col'>Numéro<br></br>de compte</th>
                    <th scope='col'>Libellé du compte</th>
                </tr>
            </thead>
            <tbody>
                {comptes.map((compte) => (
                    <tr key={compte.id_dc_num}>
                        <th scope='row'>{compte.id_dc_num}</th>
                        <td>{compte.dc_label}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default PDC_table

